"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Elastic = void 0;
var vpt_abr_network_estimator_1 = require("@sky-uk-ott/vpt-abr-network-estimator");
var abr_types_1 = require("../../abr-types");
var abr_to_player_1 = require("../../players/abr-to-player");
var DEFAULT_KP = 1 / 100;
var DEFAULT_KI = 1 / 10000; // as per quetra's implementation (1/1000) will generate negative numbers
var DEFAULT_ROUND_TRIP_TIME_ESTIMATE = 200;
var Elastic = /** @class */ (function () {
    function Elastic(logger, bandwidthEstimator, bufferAssessment, roundTripTimeEstimator, customConfig, playerConfig) {
        this.bandwidthEstimator = bandwidthEstimator;
        this.bufferAssessment = bufferAssessment;
        this.roundTripTimeEstimator = roundTripTimeEstimator;
        this.shouldWaitForBandwidth = true;
        this.tracksAscending = [];
        this.integralError = 0;
        this.drainRate = 1;
        this.lastDrainRate = 1;
        this.logger = logger.withContext('Elastic');
        this.logger.verbose('Received config: ', customConfig);
        var defaultConfig = {
            smoother: {
                type: vpt_abr_network_estimator_1.SmootherType.HARMONIC_MEAN,
            },
            kp: DEFAULT_KP,
            ki: DEFAULT_KI,
            defaultLastRoundTripTimeEstimate: DEFAULT_ROUND_TRIP_TIME_ESTIMATE,
        };
        this.config = __assign(__assign(__assign({}, defaultConfig), customConfig), { smoother: __assign(__assign({}, defaultConfig.smoother), customConfig.smoother), bufferCapacity: playerConfig.bufferCapacity });
        this.logger.info('Using config: ', this.config);
        this.bandwidthSmoother = this.bandwidthEstimator.getSmoother(this.config.smoother);
        this.lastRoundTripTimeSmoother = this.roundTripTimeEstimator.getSmoother({ type: vpt_abr_network_estimator_1.SmootherType.LAST_SAMPLE });
    }
    Elastic.prototype.getRecommendedTracks = function () {
        // r←h(S/ΔT)
        // rate = harmonicMean ( segmentSizeInBytes / downloadTime ) [last 5 segments]
        // Here we will use our harmonic mean smoother which is different
        // is slightly different the paper would suggest that we use the last 5 segments,
        // however we determine samples to use based on time, rather than number of requests.
        var rate = this.bandwidthSmoother.getValue();
        // Controller params some arbitrary values that aren't very well described.
        var _a = this.config, kp = _a.kp, ki = _a.ki;
        var bufferAhead = this.bufferAssessment.getStabilisedBufferAhead();
        var lastRoundTripTimeMs = this.lastRoundTripTimeSmoother.getValue() || this.config.defaultLastRoundTripTimeEstimate;
        // Work the integral error
        // qT can be considered buffer capacity or target buffer
        var qt = this.config.bufferCapacity;
        // (q−qT) part of the integral error calculation
        var qqt = bufferAhead - qt;
        // ΔT.(q−qT) part of the integral error calculation
        var dtqtt = lastRoundTripTimeMs * qqt;
        // qI←qI+ΔT·(q−qT)
        this.integralError = this.integralError + dtqtt;
        // r/(d−kpq−kiqI)
        var d = this.drainRate;
        var kpq = kp * bufferAhead;
        var kiqi = ki * this.integralError;
        var finalDivisor = d - kpq - kiqi;
        var level = rate / finalDivisor;
        // Quantize(r/(d−kpq−kiqI))
        return this.getTrack(level);
    };
    Elastic.prototype.getTrack = function (suggestedBandwidth) {
        if (suggestedBandwidth === void 0) { suggestedBandwidth = 0; }
        var tracksDescending = this.tracksAscending.slice().reverse();
        var trackIndex = tracksDescending.findIndex(function (track) {
            return track.combinedBandwidth <= suggestedBandwidth;
        });
        if (trackIndex === -1) {
            return this.tracksAscending[0];
        }
        return tracksDescending[trackIndex];
    };
    Elastic.prototype.playerStateChanged = function (playerState) {
        switch (playerState) {
            case abr_to_player_1.PlayerState.PAUSED:
                this.lastDrainRate = this.drainRate;
                this.drainRate = 0;
                break;
            case abr_to_player_1.PlayerState.PLAYING:
                this.drainRate = this.lastDrainRate;
                break;
        }
    };
    Elastic.prototype.setTracksAscending = function (tracksAscending) {
        this.tracksAscending = tracksAscending;
    };
    Elastic.prototype.notifiedPlaybackRateChange = function (drainRate) {
        this.drainRate = drainRate;
    };
    Object.defineProperty(Elastic.prototype, "name", {
        get: function () {
            return abr_types_1.AbrType.ELASTIC;
        },
        enumerable: false,
        configurable: true
    });
    Elastic.prototype.destroy = function () {
        this.bandwidthSmoother.unregister();
        this.lastRoundTripTimeSmoother.unregister();
    };
    return Elastic;
}());
exports.Elastic = Elastic;
